var __TEMP__ = require('./constant.js');var constant = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_defineProperty.js');var defineProperty = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./identity.js');var identity = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseSetToString;
